import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d084e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "edit-modal",
  class: "modal"
}
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-square" }, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-window-close" }, null, -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDialog',
  props: ['title', 'okBtn', 'cnlBtn', 'style'],
  emits: ['closeCancel', 'closeOk'],
  setup(__props, { emit: emits }) {

const props = __props;




function closeCancel() {
    emits('closeCancel');
}

async function closeOk() {
    emits('closeOk');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-content",
      style: _normalizeStyle(props.style)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "closecancel",
          onClick: closeCancel
        }, "×"),
        _createElementVNode("h2", null, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(props.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (!!props.okBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  style: {"float":"none"},
                  class: "okbtn",
                  onClick: closeOk
                }, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(props.okBtn), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!!props.cnlBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  style: {"float":"none"},
                  class: "cnlbtn",
                  onClick: closeCancel
                }, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(props.cnlBtn), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 4)
  ]))
}
}

})